"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPhoneE164 = exports.formatPhone = void 0;
const libphonenumber_js_1 = __importDefault(require("libphonenumber-js"));
function format(string, format, ignoreExceptions, region) {
    if (!string) {
        if (ignoreExceptions) {
            return string;
        }
        else {
            throw new Error('Required');
        }
    }
    // console.log(`Formatting ${string} to national format`);
    try {
        const number = (0, libphonenumber_js_1.default)(string, region);
        if (!number)
            throw new Error('Invalid phone number');
        if (!number.isValid())
            throw new Error('Invalid phone number');
        return number.format(format);
    }
    catch (error) {
        if (ignoreExceptions) {
            console.warn(`Error formatting \`${string}\`; ignoring.`, error.message);
            return string;
        }
        else {
            throw error;
        }
    }
}
function formatPhone(string, ignoreExceptions = true, region = 'US') {
    return format(string, 'NATIONAL', ignoreExceptions, region);
}
exports.formatPhone = formatPhone;
function formatPhoneE164(string, ignoreExceptions = true, region = 'US') {
    return format(string, 'E.164', ignoreExceptions, region);
}
exports.formatPhoneE164 = formatPhoneE164;
